const getGroupedStyle = (styles, position = "ungrouped") => [...styles[position], ...styles.applyToAll || []];
const getGroupDropdownClasses = (hasValue, isOpen, position) => {
  const activeZIndex = hasValue ? ["focus:z-2", "hover:z-2", "active:z-2"] : ["focus-visible:z-2"];
  const whenOpen = isOpen ? "z-2" : "";
  return getGroupedStyle(
    {
      first: ["s:rounded-s-sm", "mobile:rounded-t-sm", whenOpen, ...activeZIndex],
      middle: [whenOpen, ...activeZIndex, "s:-ml-1", "s:-mr-1", "mobile:-mt-1", "mobile:-mb-1"],
      last: [
        "s:rounded-e-sm",
        "mobile:rounded-b-sm",
        whenOpen,
        ...activeZIndex,
        "s:-ml-1",
        "mobile:-mt-1"
      ],
      top: [],
      "top-left": [],
      "top-right": [],
      "bottom-left": [],
      "bottom-right": [],
      ungrouped: ["rounded-sm"],
      applyToAll: ["border"]
    },
    position
  );
};
const getGroupInputClasses = (input, position) => {
  const { focused, dsf_error, dsf_success } = input;
  const zIndex = focused ? "z-2" : dsf_error || dsf_success ? "z-1" : "";
  return getGroupedStyle(
    {
      first: ["s:rounded-s-sm", "mobile:rounded-t-sm", zIndex],
      middle: [zIndex, "s:-ml-1", "s:-mr-1", "mobile:-mt-1", "mobile:-mb-1"],
      last: ["s:rounded-e-sm", "mobile:rounded-b-sm", zIndex, "s:-ml-1", "mobile:-mt-1"],
      top: [],
      "top-left": [],
      "top-right": [],
      "bottom-left": [],
      "bottom-right": [],
      ungrouped: ["rounded-sm"],
      applyToAll: ["border"]
    },
    position
  );
};
export {
  getGroupDropdownClasses,
  getGroupInputClasses,
  getGroupedStyle
};
